export const LANG_KEYS = {
  CZ: "cs-CZ",
  EN: "en-US",
  ES: "es-ES",
  HU: "hu-HU",
  PL: "pl-PL",
  RO: "ro-RO",
  SK: "sk-SK",
  LT: "lt-LT",
} as const;

export type LANGUAGE_ID = (typeof LANG_KEYS)[keyof typeof LANG_KEYS];
